var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9994 32.9334C29.8286 32.9334 32.9328 29.8293 32.9328 26.0001C32.9328 22.1709 29.8286 19.0668 25.9994 19.0668C22.1703 19.0668 19.0661 22.1709 19.0661 26.0001C19.0661 29.8293 22.1703 32.9334 25.9994 32.9334Z",
    fill: "color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 4.3335L15.5352 8.66683H8.66691C6.28358 8.66683 4.33358 10.6168 4.33358 13.0002V39.0002C4.33358 41.3835 6.28358 43.3335 8.66691 43.3335H43.3336C45.7169 43.3335 47.6669 41.3835 47.6669 39.0002V13.0002C47.6669 10.6168 45.7169 8.66683 43.3336 8.66683H36.4652L32.5002 4.3335H19.5002ZM26.0002 36.8335C20.0202 36.8335 15.1669 31.9802 15.1669 26.0002C15.1669 20.0202 20.0202 15.1668 26.0002 15.1668C31.9802 15.1668 36.8336 20.0202 36.8336 26.0002C36.8336 31.9802 31.9802 36.8335 26.0002 36.8335Z",
    fill: "color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.518610ad349252bcd6108595cc78c3b5.svg";
export { ForwardRef as ReactComponent };